const translations = {
    applicatorSummary: 'Applicator selected',
    droneMakeSummary: 'Drone make',
    fileCountSummary: 'Files staged',
    nameSummary: 'Group name',
    no: 'No',
    productUsageReportsSummary: 'Reports attached',
    workOrderSummary: 'Work order linked',
    yes: 'Yes'
};

export default translations;
